<template>
  <div class="wrap">
    <h2 v-html="c('strapLine')"></h2>
    <p><a href="mailto:hello@curiousconce.pt" class="button" v-html="c('contactButton')"></a></p>
  </div>
</template>

<script>
var content = require('../assets/content.json')

export default {
  data () {
    return {
      content: content
    }
  }
}
</script>



// WEBPACK FOOTER //
// Hello.vue?238aadd3